@if (data.header) {
  <h2 mat-dialog-title>{{data.header}}</h2>
}
<div mat-dialog-content>
  <p class="pre-line" [innerHtml]="data.text"></p>
</div>
<div mat-dialog-actions>
  <button matButton="outlined" (click)="onNoClick()">{{data.buttons?.cancel || 'Avbryt'}}</button>
  <button matButton="filled" [mat-dialog-close]="true" cdkFocusInitial>{{ data.buttons?.ok || 'OK'}}</button>
</div>